// extracted by mini-css-extract-plugin
export default {"root":"HorizontalListView_root__y2-Hw","container":"HorizontalListView_container__H-uZ2"};